import {
  QuestionReviewSubtaskInformation,
  SubtaskQuestionDetailsSection,
} from '@exam-management/new-question-review-task-details';
import { Flex } from '@shared/components';

export default function MyTaskQuestionReviewDetailsPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        width: '100%',
        bgcolor: theme.palette.grey[50],
        p: theme.spacing(6),
      })}
    >
      <QuestionReviewSubtaskInformation />
      <SubtaskQuestionDetailsSection />
    </Flex>
  );
}
